<template>
    <div v-if="!hideSection" class="py-4" :class="[!isDesktop && 'mb-8', sectionUi]">
        <OptionalContainer v-if="config.title" :with-container="!config.skipContainer">
            <h4 class="text-3xl font-semibold mb-2">{{ config.title }}</h4>
        </OptionalContainer>

        <template v-for="content in config.content" :key="content.id">
            <OptionalContainer
                v-if="
                    content.type === 'text' ||
                    content.type === 'lines' ||
                    content.type === 'button' ||
                    content.type === 'image' ||
                    content.type === 'icon' ||
                    content.type === 'card' ||
                    content.type === 'row' ||
                    content.type === 'section'
                "
                :with-container="!config.skipContainer"
            >
                <TextBlock v-if="content.type === 'text'" :config="content"></TextBlock>
                <LinesBlock v-else-if="content.type === 'lines'" :config="content"></LinesBlock>
                <ButtonBlock v-else-if="content.type === 'button'" :config="content"></ButtonBlock>
                <ImageBlock v-else-if="content.type === 'image'" :config="content"></ImageBlock>
                <IconBlock v-else-if="content.type === 'icon'" :config="content"></IconBlock>
                <CardBlock v-else-if="content.type === 'card'" :config="content"></CardBlock>
                <RowBlock v-else-if="content.type === 'row'" :config="content"></RowBlock>
                <SectionBlock
                    v-else-if="content.type === 'section'"
                    :config="content"
                ></SectionBlock>
            </OptionalContainer>
            <template v-else>
                <HeroBlock v-if="content.type === 'hero'" :config="content"></HeroBlock>
            </template>
        </template>
    </div>
</template>

<script setup lang="ts">
import CardBlock from './CardBlock.vue'
import TextBlock from './TextBlock.vue'
import LinesBlock from './LinesBlock.vue'
import ButtonBlock from './ButtonBlock.vue'
import ImageBlock from './ImageBlock.vue'
import IconBlock from './IconBlock.vue'
import RowBlock from './RowBlock.vue'
import HeroBlock from './HeroBlock.vue'
import OptionalContainer from './OptionalContainer.vue'
import { useIsDesktop } from '~~/layers/base/composables/useIsDesktop'
import type { SectionBlockConfig } from '~~/layers/base/types/blockConfigs'

const props = defineProps<{
    config: SectionBlockConfig
}>()

const { isDesktop } = useIsDesktop()
const hideSection = computed(() => Boolean(props.config.hideOnDesktop && isDesktop.value))
const sectionUi = computed(() =>
    isDesktop.value
        ? props.config.ui
        : [props.config.ui, props.config.mobileUi].filter(Boolean).join(' ')
)
</script>
